import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Box } from "@mui/material";

// Ícones padrões corrigidos
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

let DefaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

// Função para atualizar o centro do mapa quando as props mudarem
function ChangeView({ center }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center, 16);
  }, [center, map]);
  return null;
}

const MapDisplay = ({ lat, lng, titulo = "Endereço selecionado" }) => {
  const position = [lat, lng];

  return (
    <Box
      sx={{
        height: "250px",
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        border: "1px solid #ddd",
        mt: 1,
        mb: 2,
      }}
    >
      <MapContainer
        center={position}
        zoom={16}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={false}
      >
        <ChangeView center={position} />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>{titulo}</Popup>
        </Marker>
      </MapContainer>
    </Box>
  );
};

export default MapDisplay;
